<template>
  <div>
    <div class="center mgb10">
      <el-radio-group v-model="prepareType" size="small">
        <el-radio-button label="preparing">需备货，至备货中</el-radio-button>
        <el-radio-button label="prepared">已备货，至待发货</el-radio-button>
      </el-radio-group>
    </div>
    <el-row
      class="mgb10"
      v-if="prepareType == 'prepared' && !Permit.isFreeEdition()"
    >
      <el-col :span="12" :offset="6">
        <el-select
          size="small"
          v-model="shopId"
          :placeholder="$t('order.warehouse')"
          clearable
          filterable
          @change="selectShop"
        >
          <el-option
            v-for="shop in shopsInv"
            :key="shop.id"
            :label="shop.name"
            :value="shop.id"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <vxe-table
      :data="orders"
      class="recordsTable"
      size="mini"
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="images" :title="$t('product.images')" width="85">
        <template v-slot="{ row }">
          <thumbnail :images="row.images"></thumbnail>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="serialNo"
        :title="$t('text.serialNo')"
        min-width="85"
      >
        <template v-slot="{ row }">
          <small v-if="row.hurry" class="red">
            ({{ $t("order.hurrySimple") }})
          </small>
          {{ row.serialNo }}
          <div class="font10">{{ row.innerSerialNo }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productNo"
        :title="$t('product.productNo')"
        min-width="120"
      >
        <template v-slot="{ row }">
          {{ row.productNo }}
          <div class="font10">{{ row.color }} {{ row.size }}</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="quantity"
        :title="$t('text.quantity')"
        min-width="60"
      ></vxe-table-column>
      <vxe-table-column
        v-if="!Permit.isFreeEdition() && Permit.extendModels().includes('wms')"
        :title="$t('order.wmsInfo')"
        min-width="140"
      >
        <template v-slot="{ row }">
          <div v-for="i of row.inventories" :key="i.id" class="font10">
            {{ i.shopName }}：{{ i.quantity }}/{{ i.customQuantity }}
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        :title="$t('order.replenishQuantity')"
        min-width="100"
        v-if="isReplenish"
      >
        <template v-slot="{ row }">
          <el-input
            size="small"
            v-model.trim="row._replenishQuantity"
            :placeholder="$t('order.replenishQuantity')"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="handOverAt"
        :title="$t('text.handOverAt')"
        width="110"
      ></vxe-table-column>
      <vxe-table-column
        field="remark"
        :title="$t('text.remark')"
        min-width="80"
      >
        <template v-slot="{ row, rowIndex }">
          <div v-if="row.dealSuggest != null" class="red">
            <raw-html-limit-number :content="row.dealSuggest" :number="4" />
          </div>
          <div>
            <i
              slot="reference"
              class="el-icon-edit fl"
              @click="editRemark(row, rowIndex)"
            />
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </div>
          <div>
            <attribute :content="row.specJson" :number="6" />
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" :title="$t('text.action')" width="50">
        <template v-slot="{ row, rowIndex }">
          <el-button type="text" @click="remove(row, rowIndex)" size="mini">
            {{ $t("text.remove") }}
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="flex flex-between pd20">
      <div
        v-if="
          !Permit.isFreeEdition() && Permit.canActions('replenishOrderManage')
        "
      >
        <el-checkbox v-model="isReplenish" class="float-left">
          同时生成备货单
        </el-checkbox>
      </div>
      <div class="right">
        <el-button
          size="small"
          type="primary"
          :loading="submitDoing"
          @click="submit"
        >
          {{ $t("text.submit") }}
        </el-button>
        <el-button size="small" type="default" @click="close">
          {{ $t("text.close") }}
        </el-button>
      </div>
    </div>

    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('text.remark')])"
      :close-on-click-modal="false"
      :visible.sync="editRemarkDF"
      v-if="editRemarkDF"
      width="50%"
    >
      <el-form label-width="80px">
        <tinymce-editor
          ref="editor"
          v-model="editRemarkObj.remark"
          :height="300"
        ></tinymce-editor>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editRemarkDoing"
          size="small"
          @click="editRemarkSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editRemarkDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";
import Thumbnail from "@/components/Thumbnail";
import TinymceEditor from "@/components/TinymceEditor";

import Shop from "@/api/shop.js";
import Order from "@/api/order.js";

export default {
  props: {
    orders: Array,
  },
  mixins: [page],
  components: {
    Thumbnail,
    TinymceEditor,
  },
  data() {
    return {
      shopps: [],
      shopsInv: [],
      shopId: null,
      prepareType: "prepared",
      isReplenish: false,
      submitDoing: false,
      //编辑备注
      currentRowIdx: null,
      editRemarkDF: false,
      editRemarkObj: {
        remark: null,
        uuid: null,
      },
      editRemarkDoing: false,
    };
  },
  created() {
    const self = this;
    self.shopId = null;
    self.prepareType = "prepared";
    self.isReplenish = false;
    for (let order of self.orders) {
      Vue.set(order, "_replenishQuantity", order.quantity);
    }
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
      } else {
        self.sysError();
      }
    });
  },

  methods: {
    //
    editRemark(row, rowIndex) {
      this.editRemarkObj.uuid = row.uuid;
      this.editRemarkObj.remark = row.remark;
      this.currentRowIdx = rowIndex;
      this.editRemarkDoing = false;
      this.editRemarkDF = true;
    },
    editRemarkSubmit() {
      const self = this;
      self.editRemarkDoing = true;
      Order.updateRemark(self.editRemarkObj).then(function (res) {
        self.editRemarkDoing = false;
        self.editRemarkDF = false;
        if (res.status === 200) {
          self.orders[self.currentRowIdx].remark = self.editRemarkObj.remark;
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
        } else {
          self.sysError();
        }
      });
    },
    //
    selectShop() {
      const self = this;
      if (
        self.Permit.extendModels().includes("wms") &&
        self.prepareType == "prepared" &&
        self.shopId != null &&
        self.shopId != ""
      ) {
        for (const order of self.orders) {
          const obj = order.inventories.find((i) => i.shopId == self.shopId);
          if (obj == null) {
            self.$message({
              message: "存在没有库存产品的订单",
              type: "warning",
            });
            self.shopId = null;
            return;
          }
          if (
            obj != null &&
            obj.quantity - obj.customQuantity < order.quantity
          ) {
            self.$message({
              message: "存在库存数量不足的订单",
              type: "warning",
            });
            self.shopId = null;
            return;
          }
        }
      }
    },
    remove(row, rowIndex) {
      this.orders.splice(rowIndex, 1);
    },
    submit() {
      const self = this;
      if (self.orders.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneData"));
        return;
      }
      const replenishOrders = self.orders.filter((c) => c.bargainId == null);
      if (replenishOrders.length !== 0) {
        self.$message({
          message: self.$t("prompt.replenishmentNotAvailableDeal"),
          type: "warning",
        });
        return;
      }

      for (const order of self.orders) {
        if (self.isReplenish && !Util.regexQuantity(order._replenishQuantity)) {
          self.$message({
            message: self.$t("rules.regex", [
              self.$t("order.replenishQuantity"),
            ]),
            type: "warning",
          });
          return;
        }
        if (!self.isReplenish) {
          order._replenishQuantity = null;
        }
      }
      if (self.prepareType == "preparing") {
        self.submitPreparing();
      } else {
        self.submitPrepared();
      }
    },
    submitPrepared() {
      const self = this;
      if (self.Permit.isFreeEdition()) {
        self.shopId = self.shops[0].id;
      } else {
        if (self.shopId == null) {
          self.$message({
            message: self.$t("rules.select", [self.$t("order.warehouse")]),
            type: "warning",
          });
          return;
        }
      }
      const data = self.orders.map((o) => {
        return {
          id: o.id,
          replenishQuantity: o._replenishQuantity,
          shopId: self.shopId,
        };
      });
      self.submitDoing = true;
      Order.batchPrepared(data).then(function (res) {
        self.submitDoing = false;
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("prompt.dealSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchPrepared");
        } else {
          self.sysError();
        }
      });
    },
    submitPreparing() {
      const self = this;
      const data = self.orders.map((o) => {
        return { id: o.id, replenishQuantity: o._replenishQuantity };
      });
      self.submitDoing = true;
      Order.batchPrepareing(data).then(function (res) {
        self.submitDoing = false;
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.dealSuccess"),
            type: "success",
          });
          self.$emit("updateData");
          self.$eventHub.$emit("orderBatchPrepareing");
        } else {
          self.sysError();
        }
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
